import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import { CommonService } from 'src/@services/common.service';
import { FormService } from 'src/@services/form.service';
import { QBOEnvironment } from 'src/environments/environment';
import { CommonPagesService } from '../../common-pages.service';
import { ResponseStatus } from '../../enum';

@Component({
  selector: 'app-add-update-internal-transfer',
  templateUrl: './add-update-internal-transfer.component.html',
  styleUrls: ['./add-update-internal-transfer.component.scss'],

  standalone: false,
})
export class AddUpdateInternalTransferComponent implements OnInit {
  isVisibleBalanceTransferModal: any = true;
  getInternalTransferDetail: any;
  isLoadingInternalfr: any = false;
  isLoadingPrograms: any = false;
  getAllTagFlag: any = false;
  listOfProgramPeriodsDebit: any;
  listOfProgramPeriodsCredit: any;
  listOfTagsCredit: any = [];
  listOfTagsDebit: any = [];
  listOfUnfilteredDebitTags: any[] = [];
  listOfUnfilteredCreditTags: any[] = [];

  isLoadingTags: any = false;
  isLoadingTransfer: any = false;
  selectedDebitTag: any;
  selectedCreditTag: any;
  selectedTagCreditGroup: any = '';
  selectedTagDebitGroup: any = '';
  isResyncingData: boolean = false;
  @Output() hideInternalTransferDrawer = new EventEmitter();
  @Input() selectedData: any;
  qboURL = QBOEnvironment.URL;
  @ViewChild('debitDesc') debitDescRef!: ElementRef;
  @ViewChild('creditDesc') creditDescRef!: ElementRef;
  debitDescHeight: any;
  maxDescHeight: any;
  creditDescHeight: any;
  @ViewChild('tagsDDDebit') tagsDDDebit: any;
  @ViewChild('tagsDDCredit') tagsDDCredit: any;
  siteDetails: any;
  constructor(
    public _cS: CommonService,
    private _cpS: CommonPagesService,
    public _fS: FormService
  ) {
    _fS.creditInternalTransferForm_fb();
    _fS.debitInternalTransferForm_fb();
  }
  ngOnInit(): void {
    this.GetInternalfDetails();
  }

  handleCancel(data: any) {
    this.isVisibleBalanceTransferModal = false;
    this.hideInternalTransferDrawer.emit({
      hide: this.isVisibleBalanceTransferModal,
      data: data,
    });
  }

  debitSiteDetails: any;
  creditSiteDetails: any;

  loadPrograms(siteId: any, isCredit) {
    this.isLoadingPrograms = true;
    this._cpS.getProgramBySite(siteId).subscribe((response: any) => {
      if (response.responseStatus == ResponseStatus.success) {
        this.isLoadingPrograms = false;
        if (isCredit) {
          this.listOfProgramPeriodsCredit = response.result;
          this._fS.creditInternalTransferForm.patchValue({
            programPeriod:
              this.getInternalTransferDetail?.creditEntry?.program?.id,
            tags: this.getInternalTransferDetail?.creditEntry?.tag?.id,
            isNonAlc: this.getInternalTransferDetail?.creditEntry?.isNonAlc,
          });
          this.getSiteDetails(siteId, isCredit);
        } else {
          this.listOfProgramPeriodsDebit = response.result;
          this._fS.debitInternalTransferForm.patchValue({
            debitProgramPeriod:
              this.getInternalTransferDetail?.debitEntry?.program?.id,
            debitTags: this.getInternalTransferDetail?.debitEntry?.tag?.id,
            debitIsNonAlc: this.getInternalTransferDetail?.debitEntry?.isNonAlc,
          });
          this.getSiteDetails(siteId, isCredit);
        }
      } else {
        if (isCredit) {
          this.listOfProgramPeriodsCredit = [];
        } else {
          this.listOfProgramPeriodsDebit = [];
        }
        this.isLoadingPrograms = false;
        this._cS.displayMessage('error', response.message);
      }
    });
  }
  getSiteDetails(siteId: string, isCredit: boolean) {
    this._cpS.GetSiteDetails(siteId).subscribe((response: any) => {
      if (response.responseStatus == ResponseStatus.success) {
        if (isCredit) {
          this.creditSiteDetails = response.result;
        } else {
          this.debitSiteDetails = response.result;
        }
      }
    });
  }

  resynInternalTransferData() {
    this.isResyncingData = true;
    this._cpS
      .resyncInternalTransferData(this.selectedData.id)
      .subscribe((response: any) => {
        if (response.responseStatus == ResponseStatus.success) {
          if (response.result.isInternalTranferDeleted) {
            this._cS.displayMessage(
              'warning',
              'This transaction is deleted from QBO'
            );
            this.isResyncingData = false;
            this.handleCancel(response.result);
          } else {
            this.isResyncingData = false;
            this.getInternalTransferDetail = response.result;
            this._cS.displayMessage('success', response.message);
          }
        } else {
          this.isResyncingData = false;
          this._cS.displayMessage('error', response.message);
        }
      });
  }

  GetInternalfDetails() {
    this.isLoadingInternalfr = true;
    this._cpS
      .GetInternalTransferDetails(this.selectedData.id)
      .subscribe((response: any) => {
        if (response.responseStatus == ResponseStatus.success) {
          this.getInternalTransferDetail = response.result;

          this.loadPrograms(
            this.getInternalTransferDetail?.creditEntry?.siteId,
            1
          );
          this.loadPrograms(
            this.getInternalTransferDetail?.debitEntry?.siteId,
            0
          );
          this.getTags(this.getInternalTransferDetail?.creditEntry?.siteId, 1);
          this.getTags(this.getInternalTransferDetail?.debitEntry?.siteId, 0);
          this.isLoadingInternalfr = false;
        }
      });
  }

  searchTagGroupAndTags(searchTerm, searchList: any) {
    // Make the search term case insensitive
    const lowerCaseSearchTerm = searchTerm.toLowerCase();
    const listToSearch =
      searchList === 'credit' ? this.listOfTagsCredit : this.listOfTagsDebit;
    const result = listToSearch
      .map((item) => {
        // Check if the event's Name matches the search term
        const isNameMatch =
          item.Name.toLowerCase().includes(lowerCaseSearchTerm);

        // Filter the tags that match the search term
        const matchingTags = item.Tags.filter((tag) =>
          tag.Name.toLowerCase().includes(lowerCaseSearchTerm)
        );

        // If the event name matches, include the whole item with all tags
        if (isNameMatch) {
          return {
            ...item,
            Tags: item.Tags,
          };
        }

        // If there are matching tags, include the item with only those tags
        if (matchingTags.length > 0) {
          return {
            ...item,
            Tags: matchingTags,
          };
        }

        // Otherwise, exclude this item
        return null;
      })
      .filter((item) => item !== null);

    // Output the result
    return result;
  }

  returnFilteredTags(searchTerm, searchList: any) {
    if (searchTerm) {
      const filteredResult = this.searchTagGroupAndTags(searchTerm, searchList);
      if (searchList === 'credit') {
        this.listOfTagsCredit = filteredResult;
      } else {
        this.listOfTagsDebit = filteredResult;
      }
    } else {
      this.listOfTagsCredit = this.listOfUnfilteredCreditTags;
      this.listOfTagsDebit = this.listOfUnfilteredDebitTags;
    }
  }

  getTags(siteId: any, isCredit) {
    this.isLoadingTags = true;
    this._cpS.getTagsDropdownList(siteId).subscribe(
      (response: any) => {
        if (response.responseStatus == ResponseStatus.success) {
          if (isCredit) {
            this.listOfTagsCredit = response.result;
            this.listOfUnfilteredCreditTags = JSON.parse(
              JSON.stringify(response.result)
            );
          } else {
            this.listOfTagsDebit = response.result;
            this.listOfUnfilteredDebitTags = JSON.parse(
              JSON.stringify(response.result)
            );
          }
          this._fS.creditInternalTransferForm.patchValue({
            tags: this.getInternalTransferDetail?.creditEntry?.tag?.id,
          });
          this._fS.debitInternalTransferForm.patchValue({
            debitTags: this.getInternalTransferDetail?.debitEntry?.tag?.id,
          });
          // Access the DOM element using nativeElement property
          let debitDescHeight = this.debitDescRef.nativeElement.offsetHeight;
          let creditDescHeight = this.creditDescRef.nativeElement.offsetHeight;
          this.maxDescHeight = this.returnMaxHeight(
            debitDescHeight,
            creditDescHeight
          );

          if (this.getAllTagFlag == false) {
            // this.checkTagGroupData(
            //   this.getInternalTransferDetail?.creditEntry?.tag?.id,
            //   'CREDIT'
            // );
            // this.checkTagGroupData(
            //   this.getInternalTransferDetail?.debitEntry?.tag?.id,
            //   'DEBIT'
            // );
          }
          this.getAllTagFlag = true;
          // response.result.forEach((tagGroup: any) => {
          //   tagGroup.Tags.forEach((tag: any) => {
          //     this.listOfTags.push({
          //       tagGroupName: tagGroup.Name,
          //       id: tag._id,
          //       tagName: tag.Name,
          //     });
          //   });
          // });

          this.isLoadingTags = false;
        } else {
          this.isLoadingTags = false;
          this._cS.displayMessage('error', response.message);
          this.listOfTagsCredit = [];
          this.listOfTagsDebit = [];
        }
      },
      (error: any) => {
        this.isLoadingTags = false;
        this.listOfTagsDebit = [];
        this.listOfTagsCredit = [];
      }
    );
  }
  returnMaxHeight(debitSectionHeight: any, creditSectionHeight: any) {
    return Math.max(debitSectionHeight, creditSectionHeight);
  }
  checkTagGroupData(event: any, type: any) {
    var selectedGroup: any;
    var selectedTag: any;
    if (type == 'DEBIT') {
      if (this.listOfTagsDebit.length > 0) {
        this.listOfTagsDebit.forEach((element: any) => {
          element.Tags.forEach((tag: any) => {
            if (tag._id == event) {
              selectedTag = tag;
              selectedGroup = element;
            }
          });
        });
        this.selectedTagDebitGroup = selectedGroup;
        this.selectedDebitTag = selectedTag?.Name;
      }
    } else if (type == 'CREDIT') {
      if (this.listOfTagsCredit.length > 0) {
        this.listOfTagsCredit.forEach((element: any) => {
          element.Tags.forEach((tag: any) => {
            if (tag._id == event) {
              selectedTag = tag;
              selectedGroup = element;
            }
          });
        });
        this.selectedTagCreditGroup = selectedGroup;
        this.selectedCreditTag = selectedTag?.Name;
      }
    }
  }

  updateInternalTransfer() {
    if (
      this.getInternalTransferDetail.debitEntry.class == null ||
      this.getInternalTransferDetail.debitEntry.class?.id == null
    ) {
      this._fS.debitInternalTransferForm
        .get('debitPogramPeriod')
        .clearValidators();
      this._fS.debitInternalTransferForm
        .get('debitPogramPeriod')
        .updateValueAndValidity({ onlySelf: true });
      this._fS.debitInternalTransferForm.get('debitTags').clearValidators();
      this._fS.debitInternalTransferForm
        .get('debitTags')
        .updateValueAndValidity({ onlySelf: true });
    } else if (
      this.getInternalTransferDetail.creditEntry.class == null ||
      this.getInternalTransferDetail.creditEntry.class?.id == null
    ) {
      this._fS.creditInternalTransferForm
        .get('programPeriod')
        .clearValidators();
      this._fS.creditInternalTransferForm
        .get('programPeriod')
        .updateValueAndValidity({ onlySelf: true });
      this._fS.creditInternalTransferForm.get('tags').clearValidators();
      this._fS.creditInternalTransferForm.get('tags').updateValueAndValidity();
      this._fS.creditInternalTransferForm.updateValueAndValidity();
    }
    if (
      this._fS.creditInternalTransferForm.valid &&
      this._fS.debitInternalTransferForm.valid
    ) {
      this.isLoadingTransfer = true;
      var debitInternalTfrformValue = this._fS.debitInternalTransferForm.value;
      var creditInternalTfrformValue =
        this._fS.creditInternalTransferForm.value;

      var selectedProgramDebit = this.listOfProgramPeriodsDebit.find(
        (x: any) => x.id == debitInternalTfrformValue.debitProgramPeriod
      );

      var selectedProgramCredit = this.listOfProgramPeriodsCredit.find(
        (x: any) => x.id == creditInternalTfrformValue.programPeriod
      );

      var transferData = {
        transferId: this.selectedData.id,
        creditEntry: {
          program: {
            id: creditInternalTfrformValue.programPeriod,
            name: selectedProgramCredit?.label,
          },
          tag: {
            id: creditInternalTfrformValue.tags,
            name: this.selectedCreditTag,
            transcationids: [''],
          },
          isNonAlc: creditInternalTfrformValue.isNonAlc,
        },
        debitEntry: {
          program: {
            id: debitInternalTfrformValue.debitProgramPeriod,
            name: selectedProgramDebit?.label,
          },
          tag: {
            id: debitInternalTfrformValue.debitTags,
            name: this.selectedDebitTag,
            transcationids: [''],
          },
          isNonAlc: debitInternalTfrformValue.debitIsNonAlc,
        },
      };
      this._cpS
        .UpdateInternalTransfer(transferData)
        .subscribe((response: any) => {
          if (response.responseStatus == ResponseStatus.success) {
            this._cS.displayMessage('success', response.message);
            //hide transfer drawer
            this.isVisibleBalanceTransferModal = false;
            this.hideInternalTransferDrawer.emit({
              hide: this.isVisibleBalanceTransferModal,
              data: null,
            });
            this.isLoadingTransfer = false;
          } else {
            this._cS.displayMessage('error', response.message);
            this.isLoadingTransfer = false;
          }
        });
    } else {
      //to fire validations on invalid fields
      this._cS.markFormGroupTouched(this._fS.creditInternalTransferForm);

      this._cS.markFormGroupTouched(this._fS.debitInternalTransferForm);
    }
  }
  // focusTagsDDCredit(event) {
  //   if (event) {
  //     this.tagsDDCredit.focus();
  //   }
  // }
  // focusTagsDD(event) {
  //   if (event) {
  //     this.tagsDDDebit.focus();
  //   }
  // }
}
